import { SPACING_VERTICAL } from '%paysera_seat_selection/js/seatSelection/config/defaults';

function calculateRadialSeatAxis(index, circleRadius, totalPositions, spacing, seatRadius) {
    const rotationStep = 360 / totalPositions;
    const point = (index * rotationStep) * (Math.PI / 180);
    const lengthMultiplier = circleRadius + seatRadius + spacing;

    return {
        x: (Math.sin(point) * (lengthMultiplier + spacing)) + SPACING_VERTICAL * 1.5,
        y: (Math.cos(point) * (lengthMultiplier + spacing)),
    };
}

export default calculateRadialSeatAxis;
